import type { FragmentOf } from "gql.tada"
import { readFragment } from "gql.tada"
import { seaportOrderFragment } from "./seaportOrder.fragment"

type HasTypename = {
  __typename?: string
}

type WithoutTypename<T> = T extends HasTypename
  ? Omit<T, "__typename">
  : T extends Array<infer U>
    ? WithoutTypename<U>[]
    : T extends object
      ? { [K in keyof T]: WithoutTypename<T[K]> }
      : T

// This is done solely for the offer and listing mutations
// as we pass in the Order field to the input directly
function removeTypenames<T>(obj: T): WithoutTypename<T> {
  if (Array.isArray(obj)) {
    return obj.map(item => removeTypenames(item)) as WithoutTypename<T>
  }
  if (typeof obj === "object" && obj !== null) {
    const result: { [K in keyof T]?: WithoutTypename<T[K]> } = {}
    for (const key in obj) {
      if (key !== "__typename") {
        result[key as keyof T] = removeTypenames(obj[key as keyof T])
      }
    }
    return result as WithoutTypename<T>
  }
  return obj as WithoutTypename<T>
}

export const seaportOrder = (
  seaportOrder: FragmentOf<typeof seaportOrderFragment>,
) => removeTypenames(readFragment(seaportOrderFragment, seaportOrder))
